var _use, _symbol;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHuawei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 65 50",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 0.5,
    y: 0.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.56 37.62c.07-.057.1-.154.053-.235C22.818 27.097 16.843 17.403 9.803 8.5c0 0-5.597 5.3-5.198 10.632.2 2.482 1.356 4.787 3.243 6.4 4.88 4.757 16.697 10.76 19.445 12.12.087.048.196.032.264-.04m-1.824 4.08c-.037-.108-.138-.18-.253-.18v.006l-19.674.685c2.133 3.805 5.726 6.758 9.47 5.854 2.583-.646 8.437-4.728 10.364-6.106l-.002-.008c.147-.133.094-.24.094-.24m.297-1.77c.094-.155-.074-.288-.074-.288l.002-.008C17.316 33.8.568 24.85.568 24.85c-1.883 5.822 1.06 12.108 6.74 14.388a11.97 11.97 0 0 0 3.762.828c.296.055 11.7.006 14.756-.008.086-.01.162-.06.204-.137M27.335.001c-.858.074-3.17.6-3.17.6a9.13 9.13 0 0 0-6.441 6.075c-.54 2.046-.53 4.198.027 6.24 1.737 7.714 10.295 20.393 12.13 23.052.13.13.237.082.237.082.112-.027.188-.13.182-.245h.004C33.132 7.502 27.334 0 27.334 0m6.513 36.044c.108.043.23-.002.284-.106h.002c1.9-2.732 10.393-15.34 12.122-23.02a13.02 13.02 0 0 0 .033-6.239A9.13 9.13 0 0 0 39.786.606c-3.074-.76-1.504-.38-3.098-.603 0 0-5.832 7.506-2.996 35.827h.004c.001.096.06.18.15.215m4.657 5.472s-.172.023-.22.15c-.023.097.006.198.076.268h-.002c1.882 1.35 7.6 5.344 10.344 6.118 0 0 5.086 1.73 9.504-5.856l-19.7-.687zm24.94-16.708S46.718 33.782 38.07 39.617h.002c-.1.065-.13.18-.1.288 0 0 .082.147.204.147v.004l15.1-.04a11.78 11.78 0 0 0 3.388-.78 11.54 11.54 0 0 0 6.333-6.057 11.89 11.89 0 0 0 .439-8.37M36.48 37.61a.25.25 0 0 0 .266.02v.004c2.818-1.406 14.547-7.37 19.404-12.103a9.48 9.48 0 0 0 3.24-6.44C59.745 13.6 54.2 8.485 54.2 8.485a146.15 146.15 0 0 0-17.778 28.8h.006a.27.27 0 0 0 .053.313",
    stroke: "none",
    fill: "#e12229",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuawei);
export default __webpack_public_path__ + "static/media/huawei.2a3aff2ab92232bc41a27f8a1eb16d5b.svg";
export { ForwardRef as ReactComponent };